<template>
  <div class="my-2">
    <div class="pa-2 mb-2 bordered-element">
      <v-tabs
        :background-color="$vuetify.theme.themes[theme].background"
        v-model="tab"
        style="z-index: 1;"
      >
        <v-tab>
          {{ generateMessage('requests.details.titles.HO') }}
        </v-tab>
        <v-tab>
          {{ generateMessage('requests.details.titles.HNO') }}
        </v-tab>
      </v-tabs>
      <v-tabs-items
        v-model="tab"
        :style="{
          background: $vuetify.theme.themes[theme].background,
        }"
      >
        <v-tab-item>
          <div class="d-flex">
            <custom-simple-table
              style="width: 60%"
              :item="property.contractual_commitment"
              i18-path="properties_360.fields.contractual_commitment"
              table-units="hour"
              :table-keys="['intervention_limit', 'request_limit']"
            />
            <div class="d-flex flex-column px-2">
              <display-checkbox
                :label="
                  generateMessage(
                    'properties_360.fields.contractual_commitment.request_included'
                  )
                "
                :input-value="property.contractual_commitment.request_included"
              />
              <display-checkbox
                :label="
                  generateMessage(
                    'properties_360.fields.contractual_commitment.on_call'
                  )
                "
                :input-value="property.contractual_commitment.on_call"
              />
              <display-checkbox
                :label="
                  generateMessage(
                    'properties_360.fields.contractual_commitment.contract_wh_enabled'
                  )
                "
                :input-value="
                  property.contractual_commitment.contract_wh_enabled
                "
              />
            </div>
          </div>
        </v-tab-item>
        <v-tab-item>
          <div class="d-flex">
            <custom-simple-table
              style="width: 60%"
              :item="property.contractual_commitment"
              table-units="hour"
              i18-path="properties_360.fields.contractual_commitment"
              :table-keys="['intervention_limit_nwh', 'request_limit_nwh']"
            />

            <div class="d-flex flex-column px-2">
              <display-checkbox
                :label="
                  generateMessage(
                    'properties_360.fields.contractual_commitment.request_included_nwh'
                  )
                "
                :input-value="
                  property.contractual_commitment.request_included_nwh
                "
              />
              <display-checkbox
                :label="
                  generateMessage(
                    'properties_360.fields.contractual_commitment.on_call'
                  )
                "
                :input-value="property.contractual_commitment.on_call"
              />
              <display-checkbox
                :label="
                  generateMessage(
                    'properties_360.fields.contractual_commitment.contract_nwh_enabled'
                  )
                "
                :input-value="
                  property.contractual_commitment.contract_nwh_enabled
                "
              />
            </div>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>
    <custom-simple-table
      :item="property.contractual_commitment"
      i18-path="properties_360.fields.contractual_commitment"
      :table-keys="['intervention_hours']"
    />
  </div>
</template>

<script>
import CustomSimpleTable from '@/components/displays/CustomSimpleTable';
import DisplayCheckbox from '@/components/displays/DisplayCheckbox';
import { generateMessage } from '@/utils/i18n';
import { mapGetters } from 'vuex';

export default {
  name: 'MaintenanceContractInfos',
  components: { DisplayCheckbox, CustomSimpleTable },
  computed: {
    ...mapGetters({
      properties_360: 'properties_360/current',
    }),
    theme() {
      return this.$vuetify.theme.dark ? 'dark' : 'light';
    },
    property() {
      return {
        contractual_commitment: {},
        ...this.properties_360,
      };
    },
  },
  methods: {
    generateMessage,
  },

  data() {
    return {
      tab: null,
    };
  },
};
</script>

<style scoped>
@import './FRIUtils.css';
</style>
